const GOODS_NAME_SPACE = 'GOODS_REVERSAL@';

const createGoodsReverseAction = (action) => {
  return `${GOODS_NAME_SPACE}${action}`;
};

export const GoodsReverseAction = {
  initDefaultState: createGoodsReverseAction('INIT_DEFAULT_DATA'),
  setLoadingStatus: createGoodsReverseAction('SET_LOADING_STATUS'),
  setInitStatus: createGoodsReverseAction('SET_INIT_STATUS'),
  setGoodsList: createGoodsReverseAction('SET_GOODS_LIST'),
};
